import { render, staticRenderFns } from "./ButtonVoltar.vue?vue&type=template&id=ed5bb174"
import script from "./ButtonVoltar.vue?vue&type=script&lang=js"
export * from "./ButtonVoltar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports